var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { BAlert, BButton, BCard, BCardBody, BCardFooter, BCardHeader, BCollapse, BForm, BFormCheckbox, BFormGroup, BFormInput, BFormText, } from "bootstrap-vue";
import { computed, ref } from "vue";
import { Toast } from "@/composables/toast";
import localize from "@/utils/localization";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import ExternalLogin from "@/components/User/ExternalIdentities/ExternalLogin.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegisterForm',
    props: {
        sessionCsrfToken: null,
        redirect: null,
        termsUrl: null,
        enableOidc: { type: Boolean },
        showLoginLink: { type: Boolean },
        mailingJoinAddr: null,
        preferCustosLogin: { type: Boolean },
        serverMailConfigured: { type: Boolean },
        registrationWarningMessage: null
    },
    emits: ["toggle-login"],
    setup(__props, { emit }) {
        const props = __props;
        const email = ref(null);
        const confirm = ref(null);
        const password = ref(null);
        const username = ref(null);
        const subscribe = ref(null);
        const messageText = ref(null);
        const disableCreate = ref(false);
        const labelPassword = ref(localize("Password"));
        const labelPublicName = ref(localize("Public name"));
        const labelEmailAddress = ref(localize("Email address"));
        const labelConfirmPassword = ref(localize("Confirm password"));
        const labelSubscribe = ref(localize("Stay in the loop and join the galaxy-announce mailing list."));
        const custosPreferred = computed(() => {
            return props.enableOidc && props.preferCustosLogin;
        });
        function toggleLogin() {
            emit("toggle-login");
        }
        function submit() {
            return __awaiter(this, void 0, void 0, function* () {
                disableCreate.value = true;
                try {
                    const response = yield axios.post(withPrefix("/user/create"), {
                        email: email.value,
                        username: username.value,
                        password: password.value,
                        confirm: confirm.value,
                        subscribe: subscribe.value,
                        session_csrf_token: props.sessionCsrfToken,
                    });
                    if (response.data.message && response.data.status) {
                        Toast.info(response.data.message);
                    }
                    window.location.href = props.redirect ? withPrefix(props.redirect) : withPrefix("/");
                }
                catch (error) {
                    disableCreate.value = false;
                    messageText.value = errorMessageAsString(error, "Registration failed for an unknown reason.");
                }
            });
        }
        return { __sfc: true, props, emit, email, confirm, password, username, subscribe, messageText, disableCreate, labelPassword, labelPublicName, labelEmailAddress, labelConfirmPassword, labelSubscribe, custosPreferred, toggleLogin, submit, BAlert, BButton, BCard, BCardBody, BCardFooter, BCardHeader, BCollapse, BForm, BFormCheckbox, BFormGroup, BFormInput, BFormText, ExternalLogin };
    }
});
